<template>
    <fade-loader v-bind="fadeLoader">
        <v-content class="login-wrap">
            <router-view></router-view>
        </v-content>
    </fade-loader>
</template>

<script>
  export default {
    mounted () {
      this.$resolve([])
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>

</style>
